import { API_BASE_URL } from "@Platon/const"
import EimzoMixin from "./EimzoMixin"

export default {
	mixins: [EimzoMixin],
	data() {
		return {
			isEimzoLoading: false,
			isIDCardLoading: false
		}
	},
	mounted() {
		if (this.$route.query.provider === "e-imzo") {
			this.pickKey()
		}
	},
	methods: {
		pickKey() {
			let text = new Date().getTime().toString()

			this.isEimzoLoading = true

			this.$platonApp.signWithEIMZO(
				text,
				async (signResult, loadedKey) => {
					try {
						await this.completeEIMZOLogin(signResult)

						localStorage.setItem("login_eimzo_key", JSON.stringify(loadedKey))
					} catch (e) {
						this.$emit("login-error", e.message)
					}

					this.isEimzoLoading = false
				},
				{
					title: this.$l("platon.enter_whith_eimzo", "Электрон рақамли имзо билан кириш"),
					signText: this.$l("platon.enter", "Кириш"),
					timestampProvider: this.getTimestampForSignature,
					closed: () => {
						this.isEimzoLoading = false
					}
				}
			)
		},

		async pickIDCard() {
			let text = new Date().getTime().toString()
			this.isIDCardLoading = true

			try {
				const result = await this.client.createPkcs7("idcard", text, this.getTimestampForSignature)
				await this.completeEIMZOLogin(result)
			} catch (err) {
				throw new Error(err)
			} finally {
				this.isIDCardLoading = false
			}
		},

		/**
		 * @param {string} signatureHex
		 * @param {Function} cb
		 */
		async getTimestampForSignature(signatureHex, cb) {
			const timestampResult = await this.$api.get("/auth/eimzo/timestamp", {
				baseURL: API_BASE_URL,
				params: {
					signatureHex
				}
			})

			cb && cb(timestampResult.data.data)

			return timestampResult.data.data
		},

		async completeEIMZOLogin(signedPcks) {
			try {
				let loginResult = await this.$api.post("/auth/eimzo", signedPcks, {
					baseURL: API_BASE_URL,
					headers: { "Content-Type": "text/plain" }
				})

				let { token, user } = loginResult.data

				this.$emit("login-success", {
					user,
					token,
					parcel: { response: loginResult, signedPcks, type: "login-EDS" }
				})
			} catch (e) {
				// debugger

				if (e.response && e.response.data && e.response.data.message) {
					let msg = e.response.data.message

					if (msg === "Individuals are not allowed to login") {
						this.$emit("login-error", "Тизимга фақат юридик шахслар кириши мумкин")
						return
					} else if (msg === "Legal entities are not allowed to login") {
						this.$emit("login-error", "Тизимга фақат жисмоний шахслар кириши мумкин")
						return
					} else if (msg === "Invalid signer certificate") {
						this.$emit("login-error", "Калит билан имзолашда хатолик")
						return
					} else if (msg === "Revoked signer certificate") {
						this.$emit(
							"login-error",
							"Электрон имзо бекор қилинган. <a href='https://doc.platon.uz/uz/platon-users' target='_blank'>Батафсил</a>"
						)
						return
					} else if (msg === "You're not allowed to login") {
						this.$emit(
							"login-error",
							"Ушбу электрон рақамли имзо орқали тизимга киришга рухсат этилмаган. <a href='https://doc.platon.uz/uz/platon-users' target='_blank'>Батафсил</a>"
						)
						return
					}
				}

				throw e
			}
		}
	}
}
